import { useQuery } from '@apollo/react-hooks';
import React, { useEffect, useState } from 'react';
import { withApollo } from 'react-apollo';
import {
  Button,
  Jumbotron,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import './templates.css';
import { GET_CHANNELS } from '../../query/query';
import ChannelEditor from './ChannelEditor';

const ChannelsPage = () => {
  const [channels, setChannels] = useState([]);

  const [modal, toggleModal] = useState(false);
  const [modalSuccess, toggleModalSuccess] = useState(false);
  const [modalError, toggleModalError] = useState(false);

  const closeModalError = () => {
    toggleModal(false);
    toggleModalError(false);
  };

  const {
    data: { savGetChannels = [] } = {},
    loading,
    refetch,
    error,
  } = useQuery(GET_CHANNELS, {
    fetchPolicy: 'cache-and-network',
    /* context: {
      fetchOptions: {
        signal: window.AbortSignal.timeout(60000),
      },
    }, */
  });

  useEffect(() => {
    if (loading || error) return;
    setChannels(savGetChannels);
  }, [savGetChannels]);

  const onCreateChannel = () => {
    setChannels((cs) => [...cs, {
      id: '',
      name: '',
      picture: '',
      previews: [],
      premium: false,
      hidden: true,
      spicy: false,
      nameEn: '',
      nameFr: '',
      opened: true,
      generatedMessageFontSize: 72,
      generatedMessageColor: '#ffffff',
      generatedMessageMarginRight: 50,
      generatedMessageMarginLeft: 50,
      generatedMessageMarginTop: 0,
      generatedMessageMarginBottom: 0,
      generatedMessageFontFamily: 'Raleway-Regular',
      countChannelMessages: {
        total: 0,
        neverSent: 0,
      },
    }]);
  };

  return (
    <Jumbotron>
      <h3 className="display-4">
        Channels
      </h3>
      {loading && <Spinner color="primary" />}
      {(!loading || channels.length > 0) && channels.map((channel) => (
        <ChannelEditor
          channel={channel}
          isCreation={channel.id === ''}
          toggleModal={toggleModal}
          refetchChannels={refetch}
          toggleModalSuccess={toggleModalSuccess}
          toggleModalError={toggleModalError}
          opened={channel.opened}
        />
      ))}
      <Button color="success" onClick={onCreateChannel}>Add channel</Button>
      <Modal isOpen={modal} toggle={toggleModal} className="modalChannel">
        {modalSuccess && (
          <ModalBody>
            Channel created/updated
            <ModalFooter>
              {/* eslint-disable-next-line no-undef */}
              <Button color="success" onClick={() => window.location.reload()}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {modalError && (
          <ModalBody>
            Error creating/updating channel :
            {' '}
            {modalError}
            <ModalFooter>
              <Button color="danger" onClick={closeModalError}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {!modalSuccess && !modalError && (
          <Spinner color="primary" />
        )}
      </Modal>
    </Jumbotron>

  );
};

export default withApollo(ChannelsPage);



// WEBPACK FOOTER //
// ./src/components/channels/ChannelsPage.js